<template>
  <div>
    <b-form @submit.prevent="save" v-show="!isLoading">
      <b-row>
        <b-col cols="12" md="4">
          <div class="text-center">
            <img
              :src="renderLogo()"
              alt="company logo"
              class="img-thumbnail align-middle my-2"
              style="width: 200px; height: 200px; cursor: pointer"
              @error="errorImg"
            />
            <br />
            <b-modal
              no-close-on-backdrop
              variant="primary"
              header-bg-variant="primary"
              content-class="border-primary"
              v-model="view_fileManger"
              size="xl"
              ok-only
              hide-header
            >
              <UploadFile
                :crop="false"
                title="فایل‌ها"
                :file_types="file_types"
                :parentAttachmentTypeId="42"
                attachment_type_name="attachment_type_company"
                attachmentRoute="attachment_company"
                :keyServies="keyServies"
                :keyValue="keyValue"
                :showForm="false"
                :allowCollapse="false"
                :isCollapseFiles="true"
                :parentUploadFile="true"
                :showCheckbox="true"
                :maxUploadFile="10485760"
                :allowFileSize="10240"
                :outParams="{ attachment_type_id: [42] }"
              />
              <template v-slot:modal-footer>
                <b-button variant="outline-danger" @click="uploadClose">
                  <mdicon name="close" size="20" />
                  {{ $lang.close }}
                </b-button>
              </template>
            </b-modal>
            <div>
              <b-button
                v-if="showPermissionButton"
                @click="view_fileManger = !view_fileManger"
                variant="success"
              >
                <mdicon name="camera-outline" size="20" />
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="8">
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group
                :label="$lang.parent"
                label-for="parent_code_id"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.parent"
                  :rules="$v.parent_code_selected.$params"
                />
                <selectFind
                  :options="parent_code_options"
                  v-model="$v.parent_code_selected.$model"
                  label="text"
                  class="multiselect-form"
                  :isValid="null"
                  :loading="parent_code_Loading"
                  :disabled="true"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.parent_code_selected.$error ? 'block' : 'none',
                  }"
                  id="parent_code_id_feedback"
                >
                  {{ $lang.error_required | replace($lang.parent) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" v-if="mode === 'edit'">
              <b-alert show variant="info" class="mb-0">
                <mdicon name="information" size="20" class="mr-1" />
                <b v-text="$lang.company_system_alert" />
              </b-alert>
              <b-form-group
                :label="$lang.company_system_caption"
                label-for="system_caption"
                :label-cols="12"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.company_system_caption"
                  :rules="$v.system_caption.$params"
                />
                <b-form-input
                  id="system_caption"
                  type="text"
                  v-model="$v.system_caption.$model"
                  :state="
                    $v.system_caption.$dirty ? !$v.system_caption.$error : null
                  "
                  autocomplete="off"
                >
                </b-form-input>

                <b-form-invalid-feedback id="system_caption-feedback"
                  >{{
                    $lang.error_required | replace($lang.company_system_caption)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" v-if="mode === 'edit'">
              <b-form-group
                :label="$lang.company_system_url"
                label-for="system_url"
                :label-cols="12"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.company_system_url"
                  :rules="$v.system_url.$params"
                />
                <b-form-input
                  id="system_url"
                  type="text"
                  v-model="$v.system_url.$model"
                  :state="$v.system_url.$dirty ? !$v.system_url.$error : null"
                  autocomplete="off"
                >
                </b-form-input>

                <b-form-invalid-feedback id="system_url-feedback"
                  >{{
                    $lang.error_required | replace($lang.company_system_url)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group
                :label="$lang.organization_type"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.organization_type"
                  :rules="$v.organization_type_selected.$params"
                />
                <selectFind
                  :options="organization_type_options"
                  v-model="$v.organization_type_selected.$model"
                  label="text"
                  :isValid="
                    $v.organization_type_selected.$dirty
                      ? !$v.organization_type_selected.$error
                      : null
                  "
                  :placeholder="$lang.organization_type"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.organization_type_selected.$error
                      ? 'block'
                      : 'none',
                  }"
                  id="gender_id-feedback"
                >
                  {{
                    $lang.error_required | replace($lang.organization_type)
                  }}</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group
                :label="$lang.company_name"
                label-for="name"
                :label-cols="12"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.name"
                  :rules="$v.name.$params"
                />
                <b-form-input
                  id="name"
                  type="text"
                  v-model="$v.name.$model"
                  :state="$v.name.$dirty ? !$v.name.$error : null"
                  autocomplete="off"
                >
                </b-form-input>

                <b-form-invalid-feedback id="name-feedback"
                  >{{ $lang.error_required | replace($lang.name) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                :label="$lang.economic_code"
                label-for="economic_code"
                :label-cols="12"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.economic_code"
                  :rules="$v.economic_code.$params"
                />
                <b-form-input
                  id="economic_code"
                  v-model="$v.economic_code.$model"
                  type="text"
                  :state="
                    $v.economic_code.$dirty ? !$v.economic_code.$error : null
                  "
                  autocomplete="off"
                >
                </b-form-input>

                <b-form-invalid-feedback
                  v-if="!$v.economic_code.required"
                  id="economic_code-feedback"
                >
                  {{ $lang.error_required | replace($lang.economic_code) }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback
                  v-if="$v.economic_code.required && !$v.economic_code.numeric"
                  id="economic_code-feedback"
                  >{{ $lang.error_numeric | replace($lang.economic_code) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                :label="$lang.national_id"
                label-for="national_id"
                :label-cols="12"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.national_id"
                  :rules="$v.national_id.$params"
                />
                <b-form-input
                  id="national_id"
                  v-model="$v.national_id.$model"
                  :state="$v.national_id.$dirty ? !$v.national_id.$error : null"
                  type="text"
                  autocomplete="off"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!$v.national_id.required"
                  id="national_id-feedback"
                >
                  {{ $lang.error_required | replace($lang.national_id) }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback
                  v-if="$v.national_id.required && !$v.national_id.numeric"
                  id="national_id-feedback"
                  >{{ $lang.error_numeric | replace($lang.national_id) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                :label="$lang.registration_code"
                label-for="registration_code"
                :label-cols="12"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.registration_code"
                  :rules="$v.registration_code.$params"
                />
                <b-form-input
                  id="registration_code"
                  v-model="$v.registration_code.$model"
                  :state="
                    $v.registration_code.$dirty
                      ? !$v.registration_code.$error
                      : null
                  "
                  type="text"
                  autocomplete="off"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!$v.registration_code.required"
                  id="registration_code-feedback"
                >
                  {{ $lang.error_required | replace($lang.registration_code) }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback
                  v-if="
                    $v.registration_code.required &&
                    !$v.registration_code.numeric
                  "
                  id="registration_code-feedback"
                  >{{ $lang.error_numeric | replace($lang.registration_code) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                :label="$lang.type"
                label-for="is_enable"
                :label-cols="12"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.status"
                  :rules="$v.is_enable.$params"
                />
                <b-form-radio-group
                  id="is_enable"
                  autocomplete="off"
                  v-model="$v.is_enable.$model"
                  :state="$v.is_enable.$dirty ? !$v.is_enable.$error : null"
                  :options="is_enable_options"
                  buttons
                  button-variant="outline-primary"
                  size="md"
                  name="radio-btn-outline"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.description"
            label-for="description"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.description"
              :rules="$v.description.$params"
            />
            <b-form-textarea
              id="description"
              v-model="$v.description.$model"
              :rows="this.$config.form.textareaRows"
            >
            </b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <div slot="footer" class="form-group form-btn">
        <b-button
          type="submit"
          size="md"
          v-if="showPermissionButton"
          variant="success"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="handleBack"
        >
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import UploadFile from "@/components/base/uploadFile";
import { required, numeric, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  name: "edit-company-form",
  components: {
    UploadFile,
  },
  validations: {
    name: {
      required,
    },
    system_caption: {
      required: requiredIf((vm) => vm.mode === "edit"),
    },
    system_url: {
      required: requiredIf((vm) => vm.mode === "edit"),
    },
    description: {},
    economic_code: {
      numeric,
    },
    national_id: {
      numeric,
    },
    registration_code: {
      numeric,
    },
    parent_code_selected: {},
    organization_type_selected: {
      required,
    },
    is_enable: {
      required,
    },
  },
  props: {
    keyServies: {
      type: String,
      default: "",
    },
    keyValue: {
      type: String,
      default: "",
    },
    showPermissionButton: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
      default: "add",
    },
  },
  data() {
    return {
      isLoading: false,
      view_fileManger: false,
      name: "",
      economic_code: "",
      national_id: "",
      registration_code: "",
      description: null,
      is_enable: null,
      system_caption: null,
      system_url: null,
      parent_code_options: [],
      parent_code_selected: null,
      parent_code_Loading: false,
      organization_type_selected: null,
      file_types: ["image", "office", "media", "other"],
      is_enable_options: [
        {
          value: 1,
          text: "فعال",
        },
        {
          value: 0,
          text: "غیرفعال",
        },
      ],
    };
  },
  computed: {
    organization_type_options() {
      return renderEumOptions("organization_type");
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    renderEumOptions,
    generateApiUrl,
    errorImg(e) {
      if (e.type == "error") {
        e.target.src = this.$config.images.shared.noPerson;
      }
    },
    uploadClose() {
      this.view_fileManger = false;
      this.$emit("uploadClose");
      this.fetchData();
    },
    handleBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    async referenceParent() {
      try {
        this.parent_code_Loading = true;
        const url = generateApiUrl(["profile", "company_combo"]);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.parent_code_options = data.map((x) => {
          return {
            value: x.code,
            text: x.name,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.parent_code_Loading = false;
      }
    },
    async fetchData() {
      try {
        await this.referenceParent();
        this.name = pathOr("", ["name"], this.item);
        this.description = pathOr("", ["description"], this.item);
        this.economic_code = pathOr(null, ["economic_code"], this.item);
        this.national_id = pathOr(null, ["national_id"], this.item);
        this.registration_code = pathOr(null, ["registration_code"], this.item);
        this.organization_type_selected = this.organization_type_options.find(
          (x) =>
            x.value === pathOr(null, ["organization_type", "id"], this.item)
        );
        this.is_enable = pathOr(false, ["is_enable"], this.item);
        this.system_caption = pathOr(null, ["system_caption"], this.item);
        this.system_url = pathOr(null, ["system_url"], this.item);
        if (this.item.parent) {
          this.parent_code_selected = this.parent_code_options.find(
            (x) => x.value === pathOr(null, ["parent", "code"], this.item)
          );
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    renderLogo() {
      const imgKind = pathOr([], ["images_kind"], this.item);
      const imgItem = imgKind.find(
        (img) => pathOr(null, ["type"], img) === "thumb"
      );
      const address = pathOr(null, ["address"], imgItem);
      return address || this.$config.images.tinyLogo;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const payload = {
        name: this.name,
        economic_code: this.economic_code,
        national_id: this.national_id,
        registration_code: this.registration_code,
        description: this.description,
        is_enable: this.is_enable,
        organization_type_id: pathOr(
          null,
          ["value"],
          this.organization_type_selected
        ),
      };
      if (this.mode === "edit") {
        payload["system_caption"] = this.system_caption;
        payload["system_url"] = this.system_url;
      }
      this.$emit("save", payload);
    },
  },
};
</script>
